import Vue from 'vue'
import VueRouter from 'vue-router'
import indexedDB from '@/utils/indexedDB'
import Home from '@/components/page/Home.vue'
import ComingSoon from '@/components/page/ComingSoon.vue'
import TimeOut from '@/components/page/TimeOut.vue'
import NotFound from '@/components/page/NotFound.vue'

import Concept from '@/components/page/about/Concept.vue'

import Event from '@/components/page/event/Event.vue'
import EventDate from '@/components/page/event/EventDate.vue'
import EventGenre from '@/components/page/event/EventGenre.vue'
import EventStartDate from '@/components/page/event/EventStartDate.vue'
import EventStartDateDate from '@/components/page/event/EventStartDateDate.vue'
import EventStartDateGenre from '@/components/page/event/EventStartDateGenre.vue'
import EventDetail from '@/components/page/event/EventDetail.vue'

import ShopNews from '@/components/page/shop/ShopNews.vue'
import ShopNewsCategory from '@/components/page/shop/ShopNewsCategory.vue'
import ShopNewsKeyword from '@/components/page/shop/ShopNewsKeyword.vue'
import ShopNewsDetail from '@/components/page/shop/ShopNewsDetail.vue'
import ShopGuide from '@/components/page/shop/ShopGuide.vue'
import ShopGuideDetail from '@/components/page/shop/ShopGuideDetail.vue'
import Design from "@/components/page/about/Design.vue";
import Facility from "@/components/page/about/Facility.vue";
// import Function from "@/components/page/about/Function.vue";
import Legacy from "@/components/page/about/Legacy.vue";
// import Operation from "@/components/page/about/Operation.vue";
import Location from "@/components/page/about/Location.vue";
import Eco from "@/components/page/about/Eco.vue";

import Access from "@/components/page/access/Access.vue";
import Bicycle from "@/components/page/access/Bicycle.vue";
import Brt from "@/components/page/access/Brt.vue";
import Bus from "@/components/page/access/Bus.vue";
import Ship from "@/components/page/access/Ship.vue";
import Train from "@/components/page/access/Train.vue";

import Energy from "@/components/page/energy/Energy.vue";
import Environment from "@/components/page/energy/Environment.vue";
import EnergyUsage from "@/components/page/energy/EnergyUsage.vue";
import Area3 from "@/components/page/energy/area/Area-3.vue";
import Area4 from "@/components/page/energy/area/Area-4.vue";
import Area5 from "@/components/page/energy/area/Area-5.vue";
import Area6 from "@/components/page/energy/area/Area-6.vue";
import Area7 from "@/components/page/energy/area/Area-7.vue";

import Contact from "@/components/page/contact/Contact.vue";
import ContactForm from "@/components/page/contact/form/Form.vue";
import ContactFormConfirm from "@/components/page/contact/form/Confirm.vue";
import ContactFormComplete from "@/components/page/contact/form/Complete.vue";
// import ContactFormError from "@/components/page/contact/form/Error.vue";
import Policy from "@/components/page/policy/Policy.vue";
import PrivatePolicy from "@/components/page/policy/PrivatePolicy.vue";
import PrivateInfo from "@/components/page/policy/PrivateInfo.vue";

import Information from "@/components/page/information/Information.vue";
import InformationNotFound from "@/components/page/information/NotFound.vue";
import InformationDetail from "@/components/page/information/InformationDetail.vue";

import Myfavoritethings from "@/components/page/myfavoritethings/Myfavoritethings.vue";
import MyfavoritethingsForm from "@/components/page/myfavoritethings/form/Form.vue";
import MyfavoritethingsFormConfirm from "@/components/page/myfavoritethings/form/Confirm.vue";
import MyfavoritethingsFormError from "@/components/page/myfavoritethings/form/Error.vue";
import MyfavoritethingsFormComplete from "@/components/page/myfavoritethings/form/Complete.vue";
import MyfavoritethingsCategory from "@/components/page/myfavoritethings/MyfavoritethingsCategory.vue";


import Myfavoritethingsrule from "@/components/page/myfavoritethings/rule/Myfavoritethingsrule.vue";

Vue.use(VueRouter)
const usingSessionRoutes = [
    "MyfavoritethingsForm",
    "MyfavoritethingsFormConfirm",
    "MyfavoritethingsFormError",
    "MyfavoritethingsFormComplete"
];
const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: 'HARUMIFLAGタウンポータル',
            description: '住宅・交通・商業・公園・学校・保育、暮らしに必要なものが揃うALL IN TOWNな都市・HARUMIFLAGのタウンポータルサイトです。'
        }
    },

    /*==== About ====*/
    {
        path: '/about/concept',
        name: 'Concept',
        component: Concept,
        meta: {
            title: '街中に出会いがあるにぎわいの街 | HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGの街中に出会いがあるにぎわいの街のご紹介ページです。'
        }
    },
    {
        path: '/about/design',
        name: 'Design',
        component: Design,
        meta: {
            title: '地域全体のデザインに一体感のある個性的な街 | HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGの地域全体のデザインに一体感のある個性的な街のご紹介ページです。'
        }
    },
    {
        path: '/about/facility',
        name: 'Facility',
        component: Facility,
        meta: {
            title: 'みんなが使いこなし楽しみをつなぐ街 | HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのみんなが使いこなし楽しみをつなぐ街のご紹介ページです。'
        }
    },
    {
        path: '/about/location',
        name: 'Location',
        component: Location,
        meta: {
            title: 'みんなで守り、育てていく森の街 | HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのみんなで守り、育てていく森の街のご紹介ページです。'
        }
    },
    {
        path: '/about/legacy',
        name: 'Legacy',
        component: Legacy,
        meta: {
            title: 'オリンピック・パラリンピックのレガシーが息づく街 | HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのオリンピック・パラリンピックのレガシーが息づく街のご紹介ページです。'
        }
    },
    {
        path: '/about/eco',
        name: 'Eco',
        component: Eco,
        meta: {
            title: '様々なエネルギーを巧みに使いこなす街 | HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGの様々なエネルギーを巧みに使いこなす街のご紹介ページです。'
        }
    },

    /*==== Event ====*/
    {
        path: '/event',
        name: 'Event',
        component: Event,
        meta: {
            title: 'イベント情報| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのイベント一覧。おすすめのイベントをお知らせします。'
        }
    },
    {
        path: '/event/date/:id',
        name: 'EventDate',
        component: EventDate,
        meta: {
            title: 'イベント情報| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのイベント一覧。おすすめのイベントをお知らせします。'
        }
    },
    {
        path: '/event/genre/:id',
        name: 'EventGenre',
        component: EventGenre,
        meta: {
            title: 'イベント情報| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのイベント一覧。おすすめのイベントをお知らせします。'
        }
    },
    {
        path: '/event/event_start_date',
        name: 'EventStartDate',
        component: EventStartDate,
        meta: {
            title: 'イベント情報| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのイベント一覧。おすすめのイベントをお知らせします。'
        }
    },
    {
        path: '/event/event_start_date/date/:id',
        name: 'EventStartDateDate',
        component: EventStartDateDate,
        meta: {
            title: 'イベント情報| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのイベント一覧。おすすめのイベントをお知らせします。'
        }
    },
    {
        path: '/event/event_start_date/genre/:id',
        name: 'EventStartDateGenre',
        component: EventStartDateGenre,
        meta: {
            title: 'イベント情報| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのイベント一覧。おすすめのイベントをお知らせします。'
        }
    },
    {
        path: '/event/:id',
        name: 'EventDetail',
        component: EventDetail,
        meta: {
            title: 'イベント情報| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのイベント一覧。おすすめのイベントをお知らせします。'
        }
    },


    /*==== Shop ====*/
    {
        path: '/shop-news',
        name: 'ShopNews',
        component: ShopNews,
        meta: {
            title: 'ショップニュース| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのショップニュース一覧です。ショップからのおすすめ情報をお知らせします。'
        },
        props: true
    },
    {
        path: '/shop-news/category/:id',
        name: 'ShopNewsCategory',
        component: ShopNewsCategory,
        meta: {
            title: 'ショップニュース| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのショップニュース一覧です。ショップからのおすすめ情報をお知らせします。'
        },
        props: true
    },
    {
        path: '/shop-news/keyword/:id',
        name: 'ShopNewsKeyword',
        component: ShopNewsKeyword,
        meta: {
            title: 'ショップニュース| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのショップニュース一覧です。ショップからのおすすめ情報をお知らせします。'
        },
        props: true
    },
    {
        path: '/shop-news/:id',
        name: 'ShopNewsDetail',
        component: ShopNewsDetail,
        meta: {
            title: '《ショップニュースタイトル》| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAG| **《ショップニュース説明文》'
        }
    },
    {
        path: '/shop-guide',
        name: 'ShopGuide',
        component: ShopGuide,
        meta: {
            title: 'ショップガイド| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのショップ一覧です。お探しのショップを検索することができます。'
        }
    },
    {
        path: '/shop-guide/:id',
        name: 'ShopGuideDetail',
        component: ShopGuideDetail,
        meta: {
            title: '《ショップ名》| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAG| **《ショップ紹介文》'
        }
    },


    /*==== Access ====*/
    {
        path: '/access',
        name: 'Access',
        component: Access,
        meta: {
            title: 'アクセス| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのアクセス（マルチモビリティステーション）のご紹介です。'
        }
    },
    // {
    //     path: '/access/bicycle',
    //     name: 'Bicycle',
    //     component: Bicycle,
    //     meta: {
    //         title: 'コミュニティサイクルをご利用の方| HARUMIFLAGタウンポータル',
    //         description: '中央区晴海・HARUMIFLAGへのアクセス情報です。コミュニティサイクルをご利用の方へご案内いたします。'
    //     }
    // },
    // {
    //     path: '/access/brt',
    //     name: 'Brt',
    //     component: Brt,
    //     meta: {
    //         title: 'BRTをご利用の方| HARUMIFLAGタウンポータル',
    //         description: '中央区晴海・HARUMIFLAGへのアクセス情報です。BRTをご利用の方へご案内いたします。'
    //     }
    // },
    // {
    //     path: '/access/bus',
    //     name: 'Bus',
    //     component: Bus,
    //     meta: {
    //         title: 'バスをご利用の方| HARUMIFLAGタウンポータル',
    //         description: '中央区晴海・HARUMIFLAGへのアクセス情報です。バスをご利用の方へご案内いたします。'
    //     }
    // },
    // {
    //     path: '/access/ship',
    //     name: 'Ship',
    //     component: Ship,
    //     meta: {
    //         title: '船をご利用の方| HARUMIFLAGタウンポータル',
    //         description: '中央区晴海・HARUMIFLAGへのアクセス情報です。船をご利用の方へご案内いたします。'
    //     }
    // },
    // {
    //     path: '/access/train',
    //     name: 'Train',
    //     component: Train,
    //     meta: {
    //         title: '電車をご利用の方| HARUMIFLAGタウンポータル',
    //         description: '中央区晴海・HARUMIFLAGのアクセス情報です。電車をご利用の方へご案内いたします。'
    //     }
    // },

    /*==== Energy ====*/
    {
        path: '/energy',
        name: 'Energy',
        component: Energy,
        meta: {
            title: 'エネルギーマネジメント| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのエネルギーマネジメントのご紹介ページです。'
        }
    },
    {
        path: '/environment',
        name: 'Environment',
        component: Environment,
        meta: {
            title: '環境への配慮| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGの環境への配慮のご紹介ページです。'
        }
    },
    {
        path: '/energy-usage',
        name: 'EnergyUsage',
        component: EnergyUsage,
        meta: {
            title: 'エネルギーの利用状況| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのエネルギーの利用状況・街区全体のご案内ページです。'
        }
    },
    // {
    //     path: '/energy-usage/area/3',
    //     name: 'Area-3',
    //     component: Area3,
    //     meta: {
    //         title: 'エネルギーの利用状況| HARUMIFLAGタウンポータル',
    //         description: '中央区晴海・HARUMIFLAGのエネルギーの利用状況・街区全体のご案内ページです。'
    //     }
    // },
    // {
    //     path: '/energy-usage/area/4',
    //     name: 'Area-4',
    //     component: Area4,
    //     meta: {
    //         title: 'エネルギーの利用状況| HARUMIFLAGタウンポータル',
    //         description: '中央区晴海・HARUMIFLAGのエネルギーの利用状況・街区全体のご案内ページです。'
    //     }
    // },
    // {
    //     path: '/energy-usage/area/5',
    //     name: 'Area-5',
    //     component: Area5,
    //     meta: {
    //         title: 'エネルギーの利用状況| HARUMIFLAGタウンポータル',
    //         description: '中央区晴海・HARUMIFLAGのエネルギーの利用状況・街区全体のご案内ページです。'
    //     }
    // },
    // {
    //     path: '/energy-usage/area/6',
    //     name: 'Area-6',
    //     component: Area6,
    //     meta: {
    //         title: 'エネルギーの利用状況| HARUMIFLAGタウンポータル',
    //         description: '中央区晴海・HARUMIFLAGのエネルギーの利用状況・街区全体のご案内ページです。'
    //     }
    // },
    // {
    //     path: '/energy-usage/area/7',
    //     name: 'Area-7',
    //     component: Area7,
    //     meta: {
    //         title: 'エネルギーの利用状況| HARUMIFLAGタウンポータル',
    //         description: '中央区晴海・HARUMIFLAGのエネルギーの利用状況・街区全体のご案内ページです。'
    //     }
    // },

    /*==== Contact ====*/
    // {
    //     path: '/contact',
    //     name: 'Contact',
    //     component: Contact,
    //     meta: {
    //         title: 'お問い合わせ| HARUMIFLAGタウンポータル',
    //         description: '中央区晴海・HARUMIFLAGのお問い合わせについてのご案内ページです。'
    //     }
    // },
    {
        path: '/contact/form',
        name: 'ContactForm',
        component: ContactForm,
        meta: {
            title: 'お問い合わせ| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのお問い合わせについてのご案内ページです。'
        },
        props: true
    },
    {
        path: '/contact/form/confirm',
        name: 'ContactFormConfirm',
        component: ContactFormConfirm,
        meta: {
            title: 'お問い合わせ| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのお問い合わせについてのご案内ページです。'
        },
        props: true
    },
    {
        path: '/contact/form/complete',
        name: 'ContactFormComplete',
        component: ContactFormComplete,
        meta: {
            title: 'お問い合わせ| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのお問い合わせについてのご案内ページです。'
        },
        props: true
    },

    /*==== Policy ====*/
    {
        path: '/myfavoritethings/form',
        name: 'MyfavoritethingsForm',
        component: MyfavoritethingsForm,
        meta: {
            title: '写真を投稿する | HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのMY FAVORITE THINGS 写真を投稿するページです。'
        },
        props: true
    },
    {
        path: '/myfavoritethings/form/confirm',
        name: 'MyfavoritethingsFormConfirm',
        component: MyfavoritethingsFormConfirm,
        meta: {
            title: '写真を投稿する | HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのMY FAVORITE THINGS 写真を投稿するページです。'
        },
        props: true
    },
    {
        path: '/myfavoritethings/form/error',
        name: 'MyfavoritethingsFormError',
        component: MyfavoritethingsFormError,
        meta: {
            title: '写真を投稿する | HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのMY FAVORITE THINGS 写真を投稿するページです。'
        },
        props: true
    },
    {
        path: '/myfavoritethings/form/complete',
        name: 'MyfavoritethingsFormComplete',
        component: MyfavoritethingsFormComplete,
        meta: {
            title: '写真を投稿する | HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのMY FAVORITE THINGS 写真を投稿するページです。'
        },
        props: true
    },
    

    /*==== Policy ====*/
    // {
    //     path: '/policy',
    //     name: 'Policy',
    //     component: Policy,
    //     meta: {
    //         title: 'サイトのご利用について | HARUMIFLAGタウンポータル',
    //         description: '中央区晴海・HARUMIFLAGのサイトのご利用についてのご案内ページです。'
    //     }
    // },
    {
        path: '/privacypolicy',
        name: 'PrivacyPolicy',
        component: PrivatePolicy,
        meta: {
            title: '個人情報保護方針| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGの個人情報保護方針についてのご案内ページです。'
        }
    },
    // {
    //     path: '/privateinfo',
    //     name: 'PrivateInfo',
    //     component: PrivateInfo,
    //     meta: {
    //         title: '個人情報のお取り扱いについて | HARUMIFLAGタウンポータル',
    //         description: '中央区晴海・HARUMIFLAGの個人情報の取り扱いについてご案内するページです。'
    //     }
    // },
    {
        path: '/myfavoritethings/rule',
        name: 'Myfavoritethingsrule',
        component: Myfavoritethingsrule,
        meta: {
            title: '写真投稿に関する規約 | HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのMY FAVORITE THINGSの写真投稿に関する規約についてのご案内ページです。'
        }
    },

    /*==== Infomation ====*/
    {
        path: '/information',
        name: 'Information',
        component: Information,
        meta: {
            title: 'インフォメーション | HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのインフォメーション一覧。お知らせしたい情報を更新しています。'
        }
    },
    {
        path: '/information/:id',
        name: 'InformationDetail',
        component: InformationDetail,
        meta: {
            title: '《インフォメーションタイトル》| HARUMIFLAGタウンポータル',
            description: '《インフォメーションタイトル》'
        },
        // props: (route) => ({ slug: route.query.slug }),  
    },
    // {
    //     path: '/infomation/not-found',
    //     name: 'InformationNotFound',
    //     component: InformationNotFound,
    //     meta: {
    //         title: 'インフォメーション | HARUMIFLAGタウンポータル',
    //         description: '中央区晴海・HARUMIFLAGのインフォメーション一覧。お知らせしたい情報を更新しています。'
    //     }
    // },

    /*==== Myfavoritethings ====*/
    {
        path: '/myfavoritethings',
        name: 'Myfavoritethings',
        component: Myfavoritethings,
        meta: {
            title: 'MY FAVORITE THINGS | HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのMY FAVORITE THINGSのご案内ページです。'
        },
        props: true
    },
        {
        path: '/myfavoritethings/form',
        name: 'MyfavoritethingsForm',
        component: MyfavoritethingsForm,
        meta: {
            title: '写真を投稿する | HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのMY FAVORITE THINGS 写真を投稿するページです。'
        },
        props: true
    },
    {
        path: '/myfavoritethings/form/confirm',
        name: 'MyfavoritethingsFormConfirm',
        component: MyfavoritethingsFormConfirm,
        meta: {
            title: '写真を投稿する | HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのMY FAVORITE THINGS 写真を投稿するページです。'
        },
        props: true
    },
    {
        path: '/myfavoritethings/form/complete',
        name: 'MyfavoritethingsFormComplete',
        component: MyfavoritethingsFormComplete,
        meta: {
            title: '写真を投稿する | HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのMY FAVORITE THINGS 写真を投稿するページです。'
        },
        props: true
    },
    {
        path: '/myfavoritethings/:id',
        name: 'MyfavoritethingsCategory',
        component: MyfavoritethingsCategory,
        meta: {
            title: '《テーマ名》| HARUMIFLAGタウンポータル',
            description: '中央区晴海・HARUMIFLAGのMY FAVORITE THINGSのテーマごとに写真を一覧表示するページです。'
        }
    },
    /*==== others ====*/
    {
        path: '/coming-soon',
        name: 'ComingSoon',
        component: ComingSoon,
        meta: {
            title: 'HARUMIFLAGタウンポータル',
            description: '住宅・交通・商業・公園・学校・保育、暮らしに必要なものが揃うALL IN TOWNな都市・HARUMIFLAGのタウンポータルサイトです。'
        }
    },
    {
        path: '/timeout',
        name: 'TimeOut',
        component: TimeOut,
        meta: {
            title: 'HARUMIFLAGタウンポータル',
            description: '住宅・交通・商業・公園・学校・保育、暮らしに必要なものが揃うALL IN TOWNな都市・HARUMIFLAGのタウンポータルサイトです。'
        }
    },
    { path: '/:pathMatch(.*)', component:NotFound  }
]
import store from "@/store";

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    setTimeout(function() {window.scrollTo({top: 0, behavior: 'instant'})},100)
    document.title = to.meta.title || 'HARUMIFLAGタウンポータル';
    const description = to.meta.description || '住宅・交通・商業・公園・学校・保育、暮らしに必要なものが揃うALL IN TOWNな都市・HARUMIFLAGのタウンポータルサイトです。';
    document.querySelector('meta[name="description"]').setAttribute('content', description);
    // config for breadcrumb
    const breadcrumb = [];
    let title = '';
    to.matched.forEach(route => {
        // nếu có link lấy title bài viết
        switch (route.name) {
            case 'InformationDetail':
                title = 'インフォメーションタイトルタイトルタイトルタイトル...';
                break;
            case 'ShopNewsDetail':
                title = 'ショップニュース';
                break;
            case 'ShopGuideDetail':
                title = 'ショップタイトル';
                break;
            case 'EventDetail':
                title = 'イベントタイトル';
                break;
        }
        breadcrumb.push({
            name: route.name,
            path: route.path,
            data: {title} // tiêu đề trang tin tức
        });

        if (!usingSessionRoutes.includes(to.name)) {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('validated_inputform');
            sessionStorage.removeItem('validated_inputform_data');
            indexedDB.clear();
        }
    });
    store.dispatch("updateBreadcrumb", breadcrumb);
    next();
});

export default router
